import React from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useWallet } from '@solana/wallet-adapter-react';

import PoolInfo from '../components/PoolInfo';
import UserStake from '../components/UserStake';
import AdminPanel from '../components/AdminPanel';
import OnboardingSteps from '../components/OnboardingSteps';

import { usePoolState } from '../hooks/usePoolState';
import { useUserStake } from '../hooks/useUserStake';
import { ADMIN_PUBKEY, CLUSTER_URL } from '../constants';
import { ModalProvider } from '../context/ModalProvider';
require('@solana/wallet-adapter-react-ui/styles.css');

function Content() {
  const { publicKey, connected } = useWallet();
  const { poolState, loading: poolLoading, refresh: refreshPool } = usePoolState();
  const { userStakeData, userBalances, loading: userLoading, refresh: refreshUser } = useUserStake(publicKey, poolState);
  console.log("userBalances", userBalances)

  const adminPubkey = ADMIN_PUBKEY;

  if (!connected) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-bold">Welcome to MONOPOLY Staking</h2>
          <p className="text-gray-600 dark:text-gray-400">
            Connect your wallet to start earning ROLL rewards
          </p>
          <WalletMultiButton />
        </div>
      </div>
    );
  }

  const showOnboarding = !userStakeData || userBalances.rollBalance === null || userBalances.rollBalance === undefined;

  return (
    <div className="container mx-auto px-4 py-8 space-y-6">
      <ModalProvider>
        {showOnboarding ? (
          <OnboardingSteps
            isStakingAccountCreated={!!userStakeData}
            isRollWalletInitialized={userBalances.rollBalance !== null && userBalances.rollBalance !== undefined}
            onCreateStakingAccount={refreshUser}
            onInitializeRollWallet={refreshUser}
          />
        ) : (
          <>
            <UserStake
              userStakeData={userStakeData}
              userBalances={userBalances}
              poolState={poolState}
              refreshUser={refreshUser}
              refreshPool={refreshPool}
            />

            <PoolInfo
              poolState={poolState}
              refresh={refreshPool}
              loading={poolLoading}
            />
          </>
        )}
      </ModalProvider>

      {publicKey?.toBase58() === adminPubkey && (
        <AdminPanel poolState={poolState} refreshPool={refreshPool} />
      )}
    </div>
  );
}

function StakingApp() {
  const endpoint = CLUSTER_URL || 'http://127.0.0.1:8899';

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={[]} autoConnect>
        <WalletModalProvider>
          <div className="bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100">
            <header className="py-4 flex flex-col md:flex-row justify-between items-center shadow">
              <h1 className="text-xl font-bold">Stake $MONOPOLY Tokens To Earn $ROLL Rewards</h1>
              <WalletMultiButton className="btn" />
            </header>
            <Content />
          </div>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default StakingApp;
